import { Options } from 'highcharts';
import { merge } from 'lodash';
import moment from 'moment-timezone';
import { commonOptions, legendItemClick } from './highcharts-common-options';

const lightThemeOptions = (): Options => {
  const primaryColor = getComputedStyle(
    document.documentElement
  ).getPropertyValue('--ion-color-primary');
  const secondColor = getComputedStyle(
    document.documentElement
  ).getPropertyValue('--ion-color-warning');
  const thirdColor = getComputedStyle(
    document.documentElement
  ).getPropertyValue('--ion-color-success');
  const fourthColor = getComputedStyle(
    document.documentElement
  ).getPropertyValue('--ion-color-danger');

  const timezoneAbbr = moment
    .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
    .format('z');

  return {
    colors: [
      primaryColor,
      secondColor,
      thirdColor,
      fourthColor,
      '#8085e9',
      '#f15c80',
      '#e4d354',
      '#2b908f',
      '#f45b5b',
      '#91e8e1',
    ],
    chart: {
      backgroundColor: 'transparent',
    },
    xAxis: {
      labels: {
        style: {
          color: '#333333',
        },
      },
    },
    yAxis: {
      labels: {
        style: {
          color: '#333333',
        },
      },
    },
    tooltip: {
      backgroundColor: 'rgba(255, 255, 255, 0.85)',
      style: {
        color: '#333333',
      },
      dateTimeLabelFormats: {
        day: `%b %e, ${timezoneAbbr}`,
        hour: `%b %e — %l:%M%P, ${timezoneAbbr}`,
      },
      borderWidth: 0,
      shared: true,
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        borderColor: 'transparent',
        events: {
          legendItemClick,
        },
        stacking: 'normal',
      },
      column: {
        borderRadius: 1,
        pointPadding: -0.1,
        borderWidth: 0.5,
        crisp: false,
      },
    },
    legend: {
      itemStyle: {
        color: '#333333',
      },
      title: {
        style: {
          color: '#333333',
        },
      },
    },
    // Highstock specific
    navigator: {
      xAxis: {
        gridLineColor: '#D0D0D8',
      },
    },
    rangeSelector: {
      buttonTheme: {
        fill: 'white',
        stroke: '#C0C0C8',
        'stroke-width': 1,
        states: {
          select: {
            fill: '#D0D0D8',
          },
        },
      },
    },
    scrollbar: {
      trackBorderColor: '#C0C0C8',
    },
  };
};

const highChartsLightTheme = (): Options =>
  merge({}, commonOptions(), lightThemeOptions());

export { highChartsLightTheme };
